module.exports = __webpack_public_path__ + "fonts/SofiaProRegular-Italic.af462ac3.ttf";